import {
  arrayOf,
  alias,
  namedFragment,
  params,
  shape,
  string,
  typename,
} from '@thd-nucleus/data-sources';

export const dataModel = {
  quickLinks: alias('component').params({
    id: string(),
  }).shape({
    AnchorLinks: namedFragment({
      inline: true,
      fragmentType: 'AnchorLinks'
    }).shape({
      id: string(),
      theme: string(),
      linkList: arrayOf(namedFragment({
        inline: true,
        fragmentType: 'Link'
      }).shape({
        id: string(),
        href: string(),
        label: string(),
      })),
    }),
  }),
  slot: params({
    id: string(),
  }).shape({
    id: string(),
    entryId: string(),
    mediaCollections: arrayOf(shape({
      title: string(),
      entryId: string(),
      media: arrayOf(shape({
        entryId: string(),
        title: string(),
        sourceDesktop: arrayOf(shape({
          entryId: string(),
          hyperlink: string(),
        })),
        sourceMobile: arrayOf(shape({
          entryId: string(),
          hyperlink: string(),
        })),
      })),
    })),
    __typename: typename('newSlot'),
  })
};